var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useLocation } from "react-router-dom";
import React from "react";
import { getStepNavigation } from "../../../utils/nextBackStep";
var useUI = function (navigateBack, STEP, navigate, setPlanPage, setPlanLimit, setShowDetails, setShowDetail, setShowCompareDetail, setShowModalQuotes, plan, setPlan, setNamePlan) {
    var pathname = useLocation().pathname;
    var dataNavigation = React.useState(getStepNavigation(pathname))[0];
    var onClickBack = function () {
        navigate("".concat(dataNavigation === null || dataNavigation === void 0 ? void 0 : dataNavigation.back));
    };
    var onChangePage = function (e) {
        setPlanPage(e);
    };
    var onChangeRowsPerPage = function (e) {
        setPlanLimit(e);
    };
    var closeDetail = function () {
        setShowDetails(false);
        setShowDetail(false);
        setShowCompareDetail(false);
    };
    var onClickNewQuoteModal = function () {
        setShowModalQuotes(false);
        navigate("/customerForm");
    };
    var clickView = function (view) {
        var insuranceObj = __assign(__assign({}, plan), { viewType: view.id });
        setPlan(insuranceObj);
    };
    var searchFilter = function (term) {
        setNamePlan(term);
    };
    return {
        onClickBack: onClickBack,
        onChangePage: onChangePage,
        onChangeRowsPerPage: onChangeRowsPerPage,
        closeDetail: closeDetail,
        onClickNewQuoteModal: onClickNewQuoteModal,
        clickView: clickView,
        searchFilter: searchFilter,
    };
};
export default useUI;
